import { useState } from "react";
import { Button, Modal, Spin, Tooltip } from "antd";
import { InfoCircleOutlined, LinkOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { notifyBrokenLinkApi } from "../../../services/skincare.service";

const PopupButton = ({ item, noImage }: any) => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchBrokenLinkData = (product_id: any) => {
    setIsLoading(true);
    dispatch(
      notifyBrokenLinkApi({
        data: { product_id: product_id },
        finalCallback: () => {},
        successCallback: () => {
          setTimeout(() => {
            setIsModalOpen(false);
            setIsLoading(false);
          }, 200);
        },
      })
    );
  };

  return (
    <>
      <Button className="buy-btn" type="primary" onClick={showModal}>
        Buy Here
      </Button>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        width={850}
        centered
        wrapClassName="custom-modal where-buy-modal"
      >
        <div className="item">
          <div className="img-holder">
            <img
              src={item.image ?? noImage}
              alt={item?.name}
              height={120}
              width={120}
              style={{
                objectFit: "contain",
              }}
            />
            <div className="content">
              <span className="brand-name">{item.brand_name}</span>
              <span className="name">{item.name}</span>
            </div>
          </div>
          <div className="btn-groups">
            {item &&
              item?.store_info?.map((buyHereItem: any, i: any) => {
                return (
                  <div className="care-code">
                    <Button
                      href={buyHereItem.url}
                      target="_blank"
                      key={i + "__"}
                    >
                      <span>{buyHereItem.name}</span>
                    </Button>
                    {buyHereItem?.care_code && (
                      <div className="care-text">
                        * {buyHereItem?.care_code}&nbsp;
                        <div className="care-tooltip">
                          <InfoCircleOutlined />
                          <span className="care-title">
                            Use this Care Code during checkout to get discount.
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          <div className="broke__link">
            {isLoading ? (
              <Spin />
            ) : (
              <Button
                onClick={() => fetchBrokenLinkData(item?.pivot?.product_id)}
              >
                <LinkOutlined /> Notify Broken Link
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PopupButton;
